import React, { useState } from 'react';
import { Button, Container, TextField } from '@mui/material';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import { Title } from '../Home/styles';
import { DatePicker, LocalizationProvider } from '@mui/lab';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import ptbrLocal from 'date-fns/locale/pt-BR';
import { format } from 'date-fns';
import { StyledButton } from '../AreaMonitor/styles';
import ICreateRelatorioRequest from '../../Interfaces/createRelatorioRequest/createRelatorioRequest.interface';
import api from '../../Services/ApiService';
import Swal from 'sweetalert2';
import { Link } from 'react-router-dom';

// import { Container } from './styles';

const Relatorio: React.FC = () => {
  const [dataInicial, setDataInicial] = useState<string>('');
  const [dataFinal, setDataFinal] = useState<string>('');

  const validate = () => {
    if(dataInicial.length === 0 || dataFinal.length === 0 ){
      Swal.fire({
        title:'Erro!',
        text:'Selelcione a data inicial e data final!',
        icon: 'error'
      })
      return false;
    }
    const dateDataInicial = new Date(dataInicial);
    const dateDataFinal = new Date(dataFinal);
    if(dateDataInicial > dateDataFinal){
      Swal.fire({
        title:'Erro!',
        text:'A data inicial não pode ser depois da data final',
        icon: 'error'
      })
      return false;
    }
    return true;
  }

  const submitCreateRelatorio = async (event:React.FormEvent) => {
    event.preventDefault();
    if(!validate()) return;
    const createRelatorioRequest : ICreateRelatorioRequest = {
      dataInicial,
      dataFinal
    }
    try {
      const response = await api.post('/relatorios/',createRelatorioRequest,{responseType:'blob'})
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'relatorio.csv');
      document.body.appendChild(link);
      link.click();
    } catch (error:any) {
      Swal.fire({
        title:'Erro!',
        text:`${error.response.data}`,
        icon: 'error'
      })
    }
  }
  return (
    <>
      <Header active='AreaDoMonitor'/>
      <Container style={{backgroundColor:'rgba(255,255,255,0.8)',textAlign:'center', padding:'1rem', display:'flex', flexDirection:'column'}} maxWidth="lg">
        <Title>Gerar Relatório</Title>
        <form onSubmit={submitCreateRelatorio}>
          <LocalizationProvider dateAdapter={AdapterDateFns} locale={ptbrLocal}>
          <DatePicker
            renderInput={(props) => 
              <TextField 
                {...props} />
            }
            label={"Data Inicial"}
            value={new Date(dataInicial)}
            onChange={(value)=> {
              const valueString = value ? format(value, "yyyy-MM-dd'T'00:00:00") : format(new Date(), "yyyy-MM-dd'T'00:00:00");
              setDataInicial(valueString);
            }}
          />
          <div style={{margin:'20px 0px'}}></div>
          <DatePicker
            renderInput={(props) => 
              <TextField 
                {...props} />
            }
            label={"Data Final"}
            value={new Date(dataFinal)}
            onChange={(value)=> {
              const valueString = value ? format(value, "yyyy-MM-dd'T'23:59:59") : format(new Date(), "yyyy-MM-dd'T'23:59:59");
              setDataFinal(valueString);
            }}
          />
          </LocalizationProvider>
          <div style={{margin:'20px 0px'}}></div>
          <StyledButton type='submit'>
              Gerar
          </StyledButton >
        </form>
        <Link style={{color: 'inherit', textDecoration: 'inherit'}} to='/AreaDoMonitor'>
          <Button variant="contained">
            Voltar
          </Button>
        </Link>
      </Container>
      <Footer/>
    </>
  );
}

export default Relatorio;